import { useCallback } from 'react';
import { selectOccupations, useAppInitStore } from '../../stores';

export const useMemberOccupations = () => {
	const occupations = useAppInitStore(selectOccupations);

	const getOccupationById = useCallback(
		(occupationId: number) => occupations.find((g) => g.id === occupationId),
		[occupations]
	);

	return { occupations, getOccupationById };
};
